import React from "react";
import "../../assets/scss/components/generic/edModal.scss";

interface Props {
  show: boolean;
  close: () => void;
  children: React.ReactElement;
  showCloseOutOfBox?: string;
  modalClsNm?: string;
  closeClsNm?: string; //class names for close link
}

const EdModal = (props: Props) => {
  React.useEffect(() => {
    if (props.show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [props.show]);
  return (
    <>
      {props.show && (
        <div
          className={
            "modal-backdrop fade " + (props.show ? "show " : " ") + " "
          }
        ></div>
      )}
      <div
        className={"modal fade " + (props.show && "show ") + props.modalClsNm}
        tabIndex={-1}
      >
        {props.showCloseOutOfBox && (
          <a
            role="button"
            href="javascript:void(0);"
            className={"btn-close " + props.closeClsNm}
            onClick={props.close}
          >
            <i className="edel-icon-close"></i>
          </a>
        )}
        <>{props.children}</>
      </div>
    </>
  );
};

export default EdModal;
